import { yellow } from "@material-ui/core/colors";
import red from "@material-ui/core/colors/red";
import Error from "@material-ui/icons/Error";
import React, { Component } from "react";
import CustomTooltip from "../../utils/CustomTooltip";

class TooltipElement extends Component {
  state = {};
  render() {
    const { columnData } = this.props,
      delayedMessage = "day(s) already passed after maturity date",
      upcomingMessage = "day(s) until maturity date",
      daysLeft = columnData["daysLeft"],
      message =
        columnData["daysLeft"] < 0
          ? `${daysLeft.toString().replace("-", "")} ${delayedMessage} `
          : `${daysLeft} ${upcomingMessage} `;
    return (
      <CustomTooltip title={message}>
        <Error
          style={{
            color: daysLeft >= 0 ? yellow[700] : red[600],
            marginLeft: 7
          }}
        />
      </CustomTooltip>
    );
  }
}

export default TooltipElement;



// WEBPACK FOOTER //
// ./src/components/FormElement/TooltipElement.js